import { formatUsPhone, SignatureTemplateParams } from './TemplateParams';

export function SignatureTemplate({
  params,
  showPhoto = false,
}: {
  params: SignatureTemplateParams;
  showPhoto?: boolean;
}) {
  const { name, title, email, phone, disablePhoneNumber } = params;
  if (showPhoto === true) {
    return <>photo</>;
  }

  return (
    <table
      style={{ fontFamily: 'sans-serif, Arial', lineHeight: '22px', borderCollapse: 'collapse' }}
      //@ts-expect-error because
      border="0"
      cellpadding="0"
      cellspacing="0"
      width="100%"
      role="presentation"
    >
      <tr
        style={{ borderCollapse: 'collapse' }}
        //@ts-expect-error because
        border="0"
        cellpadding="0"
        cellspacing="0"
        width="100%"
      >
        <td
          style={{ borderCollapse: 'collapse' }}
          //@ts-expect-error because
          border="0"
          cellpadding="0"
          cellspacing="0"
          width="100%"
        >
          <div style={{ color: '#1A6BAF', fontWeight: 'bold', fontSize: '18px', border: '0px' }}>
            {name ? name : 'Your name here'}
          </div>
          <div style={{ color: 'black', border: '0px' }}>{title ? title : 'Your title here'}</div>
          <div style={{ color: '#7A7A7A', paddingTop: '10px', paddingBottom: '4px', border: '0px' }}>
            <a href={`mailto:${email}`} style={{ color: '#7A7A7A', textDecoration: 'none' }}>
              {email ? email : 'your-email@teamsnap.com'}
            </a>
            <br />
            {disablePhoneNumber ? '' : phone ? formatUsPhone(phone) : formatUsPhone('0000000000')}
            {!disablePhoneNumber ? <br /> : ''}
          </div>
          <div>
            <img
              src="https://ts-public-assets.teamsnap.com/email/signatures/tsc/v1/line-3rXw8ekVzJczKCVlc1nAL.png"
              width="233"
              alt="Line separator"
            />
          </div>
          <div>
            <a href="https://www.teamsnap.com/?utm_source=Email&utm_medium=Email&utm_campaign=TS-Signature&utm_content=ts-home-link">
              <img
                src="https://ts-public-assets.teamsnap.com/email/signatures/tsc/v1/logo-PxpG7XjRcxVQD62a_08Fw.png"
                alt="TeamSnap logo"
                width="137"
              />
            </a>
          </div>
          <div style={{ color: '#FF5B01', fontSize: '12px', border: '0px' }}>
            <a
              href="https://www.teamsnap.com/?utm_source=Email&utm_medium=Email&utm_campaign=TS-Signature&utm_content=ts-home-link"
              style={{ color: '#FF5B01', textDecoration: 'none' }}
            >
              Learn more about us
            </a>{' '}
            |{' '}
            <a
              href="https://www.teamsnap.com/leagues-and-clubs/signup/?utm_source=Email&utm_medium=Email&utm_campaign=TS-Signature&utm_content=ts-c_and_l-link"
              style={{ color: '#FF5B01', textDecoration: 'none' }}
            >
              Book a demo
            </a>
          </div>
        </td>
      </tr>
    </table>
  );
}
